import './bootstrap';
import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import { createInertiaApp } from '@inertiajs/vue3';
import { GesturePlugin } from '@vueuse/gesture'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import WebApp from '@twa-dev/sdk';
import * as Sentry from "@sentry/vue";

import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';
import { DefaultApolloClient } from '@vue/apollo-composable';

const httpLink = createHttpLink({
    uri: import.meta.env.VITE_GRAPHQL_ENDPOINT,
});

const cache = new InMemoryCache();

const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
const pinia = createPinia();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(GesturePlugin)
            .provide(DefaultApolloClient, apolloClient);

        Sentry.init({
            app,
            dsn: "https://e895a330e42099344b4a8d0a6a626ae3@rediculustotalus.in/26",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            tracesSampleRate: 1.0,
            // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
            /* tracePropagationTargets: ["localhost", "remotehost", "remotehost:8010"], */

            // Capture Replay for 10% of all sessions,
            // plus for 100% of sessions with an error
            // Learn more at
            // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
            replaysSessionSampleRate: 1.0,
            replaysOnErrorSampleRate: 1.0,
        });

        WebApp.ready();
        WebApp.expand();

        app.mount(el);
    }
});
